import React from 'react';
import { makeStyles, Typography } from '@smile-next/uikit';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 80,
        width: '100%',
    },
}));

export const LoginFormHeader: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography bold variant="heading">
                ログイン
            </Typography>
        </div>
    );
};
